import { Box, Typography } from '@mui/material';
import { palette } from '@ahora-patagonia/design-tokens';
import type { NotaPublicaCard, PublicCategoryRef } from '@ahora-patagonia/contracts';
import { ListadoNotas } from '../../../shared/notas/ListadoNotas.js';

export interface MasDeCategoriaProps {
  category: PublicCategoryRef;
  notas: NotaPublicaCard[];
}

/**
 * El pie de la nota: *Más de <categoría>* con las últimas publicadas. **No hay
 * recomendación por afinidad** y el título lo dice honestamente (handoff §1.3).
 */
export function MasDeCategoria({ category, notas }: MasDeCategoriaProps) {
  if (notas.length === 0) return null;
  return (
    <Box component="section" sx={{ mt: 5 }}>
      <Typography
        variant="tituloBloque"
        component="h2"
        sx={{ borderBottom: `2px solid ${palette.ink}`, pb: 0.5, mb: 1 }}
      >
        Más de {category.name}
      </Typography>
      <ListadoNotas notas={notas} />
    </Box>
  );
}
